import {trackPromise} from "react-promise-tracker";
import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";

export const getSites = ({customerId, type, pageUrl = ""}, payload) => {
  let url = getUrl("sites")(customerId);
  let patchUrl;
  switch (type) {
    case "get":
      return trackPromise(Call.get(pageUrl || url));
    case "post":
      return trackPromise(Call.post(url, payload));
    case "patch":
      patchUrl = `${url}${payload.id}/`;
      return trackPromise(Call.patch(patchUrl, payload));
    case "delete":
      patchUrl = `${url}${payload.id}/`;
      return trackPromise(Call.delete(patchUrl));
    default:
      return;
  }
};

export const getSiteForFavControllerAsync = (customerId, siteId) => {
  let url = `${getUrl("sites")(customerId)}${siteId}/`;
  return trackPromise(Call.get(url));
};

export const getLocations = ({customerId, siteId, method}, payload) => {
  let url = getUrl("location")(customerId, siteId);
  let patchUrl;
  switch (method) {
    case "get":
      return trackPromise(Call.get(url));
    case "post":
      return trackPromise(Call.post(url, payload));
    case "patch":
      patchUrl = `${url}${payload.id}/`;
      return trackPromise(Call.patch(patchUrl, payload));
    case "delete":
      patchUrl = `${url}${payload.id}/`;
      return trackPromise(Call.delete(patchUrl));
  }
};

export const getLocationForFavControllerAsync = (customerId, siteId, locationId) => {
  let url = `${getUrl("location")(customerId, siteId)}${locationId}/`;
  return trackPromise(Call.get(url));
};

export const postClaimController = ({customerId, siteId, locationId}, payload) => {
  return trackPromise(
    Call.post(getUrl("claim_controller")(customerId, siteId, locationId), payload)
  );
};

export const postUnClaimController = ({customerId, siteId, locationId}, payload) => {
  return trackPromise(
    Call.post(getUrl("unclaim_controller")(customerId, siteId, locationId), payload)
  );
};
